<template>
  <div class="toolbar" v-if="!editMode">
    <div class="container-fluid">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  /* eslint spec-file: 0 */

  export default {
    computed: {
      editMode() {
        return this.$route.params.page === 'edit'
      }
    }
  }

</script>

<style scoped lang='scss'>
  @import "~@/assets/sass/_variables.scss";
  .toolbar {
    padding: .7em 0;
    margin: -1px -15px 0;
    text-align: right;
    .btn {
      margin-left: .5em;
    }
    @include theme {
      border-top: 1px solid v(background-light);
      background: v(background-lightest);
    }
    box-shadow: 0 2px 5px lighten($gray-color, 70%);
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Payment/Toolbar.vue